import * as Sentry from "@sentry/react-router";
import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

Sentry.init({
  dsn: "https://79418b5792bbdda1704de14d3a513319@o4511341633142784.ingest.us.sentry.io/4511341637664768",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0,
});

// Note: Not using StrictMode to prevent double-mounting of WebGL components
// which causes context loss. In production, StrictMode is not active anyway.
startTransition(() => {
  hydrateRoot(document, <HydratedRouter />, {
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
  });
});
